import { useEffect, useState } from 'react';
import AfricaMap from './Components/AfricaMap';
import CountryInfo from './Components/CountryInfo';
import FlagList from './Components/FlagList';

const mapStyle = {
	width: "100%",
	height: "100%",
	cursor: "pointer"
}



function Index({langcode}: {langcode: string}) {

	
	let [selectedCountryCode, setSelectedCountryCode] = useState(null as any)

	const getDefaultCountry = () => {
		let elem = document.getElementById("default-country")
		return elem
	}

	useEffect(() => { 
		let defaultCountryElement = getDefaultCountry()
		let countryCode = defaultCountryElement?.getAttribute("data-country")
		setSelectedCountryCode(countryCode)
	},[]);

	const onMapClick = (e: any) => {
		let countryCode = e.target.getAttribute("data-country")
		if(countryCode == null) return
		setSelectedCountryCode(countryCode)
	}

	const onFlagClick = (countryCode: any) => {
		setSelectedCountryCode(countryCode)
	}
	

	return (
		<div className="sadc-map">
			<div className="row">
				<div className="col-lg-5 col-12">
					<FlagList onClick={onFlagClick} selected={selectedCountryCode} langcode={langcode.slice(0,2)}/>
					<CountryInfo selectedCountryCode={selectedCountryCode} langcode={langcode.slice(0,2)}/>
				</div>
				<div className="col-lg-7 col-12" >
					<div className='map-container' style={mapStyle}>
						<AfricaMap onClick={onMapClick} selected={selectedCountryCode} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Index
